import { Component, OnInit, Input, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { typeDHLFormControls } from '../../models/dhl-form-shared-types';
import { FormService } from '../../services/form.service';
import { AppService } from 'src/app/app.service';
import { APP_Constants } from '../../../../app.constant';
import { DhlFormControl } from '../../models/dhl-form-control';
import { MatDialogConfig, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { Subject } from 'rxjs';
import { DhlFormControlEvent } from '../../models/dhl-form-control-event';
import { DhlFormControlEventData } from '../../models/dhl-form-control-event-data';

@Component({
    selector: 'app-form-field-input',
    templateUrl: './form-field-input.component.html',
    styleUrls: ['./form-field-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFieldInputComponent implements OnInit, AfterViewInit {

  @Input() configData: DhlFormControl;
  @Input() frmGroup: UntypedFormGroup;

  validationType: string = '';
  isSpinnerShow: boolean = false;
  confirmDlg: MatDialogRef<ModalComponent>;

  constructor(private formService: FormService, private appService: AppService, public matDialog: MatDialog) { }

  get f() { return this.frmGroup.controls; }

  checkMaxlengthChar(value) {
    value = value.trim();
    if(this.configData.type !== 'number'){
      this.frmGroup.get(this.configData.name).setValue(value.trim())
    }
    if (this.configData['maxLength'] && value.length > parseInt(this.configData['maxLength'])) {
      this.frmGroup.get(this.configData.name).setErrors({ 'maxLength': { 'exceedsChar': value.length - parseInt(this.configData['maxLength']) } });
    }
    if (this.configData['minLength'] && value.length < parseInt(this.configData['minLength'])) {
      this.frmGroup.get(this.configData.name).setErrors({ 'minLength': { 'requiredChar': parseInt(this.configData['minLength']) - value.length } });
    }
    if (this.configData['upperCase'] && !this.frmGroup.get(this.configData.name).errors){
      this.frmGroup.get(this.configData.name).setValue(value.toUpperCase());
    }
    if (this.frmGroup.get(this.configData.name).valid) {
      this.eventFactory();
    }
  }
  // removeToggle: boolean = false;
  ngOnInit() {
    if (this.configData['editable'] === false) {
      this.frmGroup.get(this.configData.name).disable();
    }

    this.configData?.validation?.forEach((validataion:string | any) => {
      let element =  (typeof validataion == "object" ? validataion.name : validataion);
      if (element === "Numeric") {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).setValidators(Validators.min(1));
        this.frmGroup.get(this.configData.name).setValidators(Validators.pattern(new RegExp('^0*[1-9]\\d*$')));
      }
      else if (element === 'Decimal') {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).setValidators(Validators.min(1));
        this.frmGroup.get(this.configData.name).setValidators(Validators.pattern(new RegExp('^\\s*(?=.*[1-9])\\d*(?:\\.\\d{1,99})?\\s*$')));
      }
      else if (element === 'DecimalWithMaxlength') {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).setValidators(Validators.pattern(new RegExp(/^\s*(?=.*[1-9])\d{1,3}(?:\.\d{1,2})?\s*$/)));
      }
      if (element === "NoSpecialCharacter") {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).setValidators(Validators.pattern(new RegExp('^((?![$<>?%&*#!~` +]).).*\\S*$')));
      }
      if (element === 'Email') {
        let newexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        this.validationType = element;
        this.frmGroup.get(this.configData.name).setValidators(Validators.pattern(newexp));
      }
      if (element === 'hidden') {
        if (!(this.frmGroup.get(this.configData.name)['hidden'] === false)) {
          this.frmGroup.get(this.configData.name)['hidden'] = true;
        }
      }
      if (element === "customValidation") {
        this.validationType = element;
        // this.frmGroup.get(this.configData.name).setValidators(countryCodeValidator(this.configData['customValidation'], this.frmGroup.get(this.configData['sourceControl'])));
        this.frmGroup.get(this.configData.name).setValidators(this.customValidator(validataion));
      }
    }, this);
  }

  ngAfterViewInit() {
    let form = this.frmGroup.get(this.configData.name)
    this.configData?.validation?.forEach(element => {
      if (element === 'hidden') {
        setTimeout(function () {
          form.setValidators(null);
          form.updateValueAndValidity();
        }, 100);
      }
    });
  }

  /** Here we can add more custom events conditional basis
   * 1. checking this input have change event
   * 2. checking action
   * 3. we can add more action at tempalte & we can create new methods
  */
  eventFactory() {
    if (!this.configData.events || !this.configData.events.length) {
      return
    }
    let tabEvent = this.configData.events.filter(item => item.event == 'CHANGE')
    if (tabEvent && tabEvent.length) {
      if (tabEvent[0].action == "VERIFY_DOMAIN") {
        this.customerOnBoarding(tabEvent);
      } else if (tabEvent[0].action == "VERIFY_USERNAME") {
        this.verifyUserName(tabEvent);
      }
    }
  }

  onCommonEventHander(eventType){
    if (this.frmGroup.get(this.configData.name).valid) {
      let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events, eventType);
      if (event) {
        this.sendToSource(event, null);
        return
      }
    }
  }

  customerOnBoarding(tabEvent) {
    // To avoid form getting submitted
    this.frmGroup.get(this.configData.name).setErrors({ 'loading': {} });
    this.isSpinnerShow = true;
    let config = {
      actions: true,
      name: "Confirm",
      title: "Available Domain?",
      description: "Entered domain name is available only in test, dev prod, Would you like proceed?",
      actionButtonText: "Proceed"
    }
    let validationMessage = "Please enter different domain name";
    const subject = new Subject<boolean>();
    let value = this.frmGroup.get(this.configData.name).value;
    let httpConfig = tabEvent[0].config;
    let url = APP_Constants.ADMIN_SEARCH_DOMAIN_URI;
    url += localStorage.getItem('customerCode');
    url += '&userId=' + localStorage.getItem('userName');
    url += '&action=VERIFY_DOMAIN';
    url += '&domainName=' + value;
    this.appService.makeHttpGetRequest(url)
      .subscribe((response: any) => {
        // Remove Error(loading)
        this.frmGroup.get(this.configData.name).setErrors(null);
        let availableEnvironments = [];
        let unAvailableEnvironments = [];
        let failedEnvs = [];
        // Checking If any one or more OTM env is down.
        response.data.forEach(envDt => {
          if(!envDt.domainAvailability && envDt.message == "OTM call failed"){
            failedEnvs.push(envDt.environment.toUpperCase());
            config.actions = false;
            validationMessage = "Please try again later.";
          }else if (!envDt.domainAvailability) {
            unAvailableEnvironments.push(envDt.environment.toUpperCase());
          } else {
            availableEnvironments.push(envDt.environment.toUpperCase());
          }
        });
        if (unAvailableEnvironments.length || failedEnvs.length) {
          // Domain available at some env & unavailable at some env so open prompt and get user confirmation
          config.description = `Entered domain name is already exists in ${unAvailableEnvironments.join(", ").replace(/,(?=[^,]*$)/, ' and ')}, `;
          if(availableEnvironments.length){
            config.description += `domain will be created in ${availableEnvironments.join(", ").replace(/,(?=[^,]*$)/, ' and ')} environment, `;
          }
          config.description += `Would you like proceed?`;
          // If any one or more OTM env is down. We need to show different alert message.
          if(failedEnvs.length){
            config.description = `OTM ${failedEnvs.join(", ").replace(/,(?=[^,]*$)/, ' and ')} environment is not available. Please try again later.`;
          }
          let modalConfig: MatDialogConfig<any> = new ModalConfig(config);
          this.confirmDlg = this.matDialog.open(ModalComponent, modalConfig);
          this.confirmDlg.componentInstance.subject = subject;
          this.confirmDlg.afterClosed()
            .subscribe(async response => {
              if (response) {
                return true;
              } else {
                this.frmGroup.get(this.configData.name).setErrors({ 'unAvailable': { 'message': validationMessage } });
                return false;
              }
            });
        }
        this.isSpinnerShow = false;
      }, (err) => {
        // Remove Error(loading)
        this.frmGroup.get(this.configData.name).setErrors(null);
        this.isSpinnerShow = false;
        console.log('err', err);
        if (err['message'].statusCode == APP_Constants.ERROR_CODE) {
          this.frmGroup.get(this.configData.name).setErrors({ 'unAvailable': { 'message': err['data']['message'] } });
        }
      });
  }

  verifyUserName(tabEvent) {
    this.frmGroup.get(this.configData.name).setErrors({ 'checking': true });
    this.isSpinnerShow = true;
    let value = this.frmGroup.get(this.configData.name).value;
    let httpConfig = tabEvent[0].config;
    let url = APP_Constants.ADMIN_SEARCH_USERNAME_URI;
    url += '&loggedInUser=' + localStorage.getItem('userName');
    url += '&userId=' + value;
    this.appService.makeHttpGetRequest(url)
      .subscribe((response) => {
        this.frmGroup.get(this.configData.name).setErrors(null);
        this.isSpinnerShow = false;
        // Since it is reverse auto complete no need handle success
        if (response['message'].statusCode == APP_Constants.ERROR_CODE) {
          this.frmGroup.get(this.configData.name).setErrors({ 'unAvailable': { 'message': response['message']['statusMessage'] } });
        }
      }, (err) => {
        this.frmGroup.get(this.configData.name).setErrors(null);
        this.isSpinnerShow = false;
        console.log('err', err);
        if (err.status == APP_Constants.HTTP_CONFLICT) {
          this.frmGroup.get(this.configData.name).setErrors({ 'unAvailable': { 'message': err['message'] } });
        }
      });
  }

  customValidator(validataionProps): ValidatorFn{
    let me = this;
    return (control): { [key: string]: any } | null => {
      let sourceControl = me.frmGroup.get(validataionProps['sourceControl']);
      if(!control.value || !sourceControl || !sourceControl.value || !sourceControl.value.value){
        return null;
      }
      let option = validataionProps.options.filter(option => option.value ==  sourceControl.value.value)[0];
      let newRegExp = new RegExp(option.pattern.toString());
      let forbidden = newRegExp.test(control.value);
      let validationMessage = option.message;
      control.markAsTouched();
      return !forbidden ? { customValidation: { value: control.value, 'message': validationMessage } } : null;
    }
  }

  /** Common Method to check event exist in template */
  checkEventExist(events, eventName): DhlFormControlEvent | null {
    let event = null;
    if (events && Array.isArray(events)) {
      event = events.filter(ele => ele.event == eventName);
      event = (event.length ? event[0] : null);
    }
    return event;
  }

  sendToSource(event: DhlFormControlEvent, data = {} ) {
    let eventData: DhlFormControlEventData = {
      event: event.event,
      eventData: event,
      action: event.action,
      name: this.configData.name,
      component: this,
      configData: this.configData,
      data: data,
    }
    this.appService._commonComponentSubject.next(eventData);
  }
}
